import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import { createProvider } from './vue-apollo'
import axios from "@/axios-client";
import VueAxios from "vue-axios";
import apolloClient from "@/apollo-client";
import VueApollo from "vue-apollo";
import Icon from "@/icons/Icon";
import IconButton from "@/components/IconButton";
import LoadingButton from "@/components/LoadingButton";

export default async function () {
  Vue.component("Icon", Icon);
  Vue.component("IconButton", IconButton);
  Vue.component("LoadingButton", LoadingButton);
  await store.dispatch("me"); // check if we're authenticated
  Vue.use(VueAxios, axios);
  Vue.use(VueApollo);
  const apolloProvider = new VueApollo({
    defaultClient: apolloClient,
  });

  Vue.config.productionTip = false;
  Vue.config.devtools = process.env.NODE_ENV === "development";

  new Vue({
    router,
    store,
    apolloProvider,
    render: (h) => h(App),
  }).$mount("#app");
}
